import { useSiteStore } from '@/store/site';
import { cloudUrlParser } from '@/utils/aws-domain-util';
import { ApiQueryBasePromise } from '@/types';
import { ApiSuccessResponse } from '@nf/types/api';
import { getResponseJwtHeader } from '@/utils/web';
import queryKeys from '@/constants/query-keys';
import { useAuthToken } from '@/store/auth';
import { useQuery } from '@tanstack/react-query';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useGetSiteConfigs } from '../query/use-site-configs';
import { visitorAtom } from '@/atoms/visitor';
import { useAtomValue } from 'jotai';

const getWinnerList = async (authToken: string): Promise<ApiQueryBasePromise<ApiSuccessResponse<WinnerListResponse>>> => {
	const { ctcdDomain } = useSiteStore.getState().apiDomain;
	const response = await fetchComposer.getWithBearer(cloudUrlParser(`${ctcdDomain}/api/Customer/GetNickName`))(authToken);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}

	return {
		data: await response.json(),
		jwtToken: getResponseJwtHeader(response)
	};
};

type WinnerListResponse = {
	IBCCustId: number;
	NickName: number | null;
	UserName: string | null
}[];

export const useGetWinnerList = () => {
	const authToken = useAuthToken();
	const visitorInfo = useAtomValue(visitorAtom);
	const beforeToken = visitorInfo?.AccessToken;
	const token = authToken || beforeToken;
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [queryKeys.GET_SPORT_EVENT_WINNER_LIST, token],
		queryFn: () => getWinnerList(token!),
		refetchOnWindowFocus: false,
		enabled: !!token && siteConfig?.EnableSportEventWinnerList
	});

	return {
		winnerListForShow: data?.data.Data?.slice(0, 10), // 只取前10筆資料, 方便後面塞測試資料
		winnerListContainTestData: data?.data.Data,
		isLoading,
		isError,
		error,
		refetch,
	};
};